import { useOptionalSession } from 'src/contexts/SessionContext';

import { CollectionTags } from './utils';

export function useCollectionTags(): CollectionTags {
  const { session } = useOptionalSession();

  return {
    productTags: session?.productTags || [],
    packageTags: session?.packageTags || [],
  };
}
